import React from "react";

export function useTrackFocusState(): readonly [
	boolean,
	() => void,
	() => void
] {
	const [isFocused, setFocused] = React.useState(false);

	const onFocus = React.useCallback(() => {
		setFocused(true);
	}, []);

	const onBlur = React.useCallback(() => {
		setFocused(false);
	}, []);

	return [isFocused, onFocus, onBlur];
}
